import { space, layout, flexbox, grid, typography, border, position, shadow, color, } from 'styled-system';
import styled from '../../styles/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
export const Box = styled('div', {
    shouldForwardProp,
})({
    minWidth: 0,
}, space, layout, flexbox, grid, typography, border, position, shadow, color);
//# sourceMappingURL=box.js.map